import React from "react";

class ErrorBoundary extends React.Component<{children:React.ReactNode},{hasError:boolean}>{
  state={hasError:false};
  static getDerivedStateFromError(){return{hasError:true};}
  componentDidCatch(e:any,i:any){console.error(e,i);}
  render(){return this.state.hasError ? <div>Oups — une erreur est survenue. Recharge la page.</div> : this.props.children;}
}

export { ErrorBoundary };
